import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { saveFunnerUserDetails } from 'api/app-users';
import { dispatch, store } from 'store';
import { ApplicationUser } from 'types/company/applicationUser';
import { fetcher } from 'utils/axios';
import { stripClerkUserIdPrefix, udidKey } from 'utils/auth/clerkUserId';

const initialState: ApplicationUser[] = [];

const applicationUsersSlice = createSlice({
  name: 'applicationUsers',
  initialState,
  reducers: {
    setApplicationUsers(state, action: PayloadAction<ApplicationUser[]>) {
      return action.payload;
    },
    updateSingleApplicationUser(
      state,
      action: PayloadAction<{ userId: string; params: Partial<ApplicationUser> }>,
    ) {
      const { userId, params } = action.payload;
      const idKey = udidKey(userId);
      return state.map((appUser) => {
        if (udidKey(appUser.Udid) === idKey) {
          return { ...appUser, ...params };
        }
        return appUser;
      });
    },
    resetApplicationUsers() {
      return initialState;
    },
  },
});

export default applicationUsersSlice.reducer;
export const { setApplicationUsers, updateSingleApplicationUser, resetApplicationUsers } =
  applicationUsersSlice.actions;

function normalizeApplicationUsersList(users: ApplicationUser[]): ApplicationUser[] {
  return users.map((u) => ({
    ...u,
    Udid: stripClerkUserIdPrefix(u.Udid) ?? u.Udid,
  }));
}

export async function getApplicationUsers() {
  try {
    const data = await fetcher('get', '/api/auth/getApplicationUsers', 'history');
    if (data?.result) {
      dispatch(setApplicationUsers(normalizeApplicationUsersList(data.users as ApplicationUser[])));
    }
  } catch (error) {
    console.warn('getApplicationUsers err: ', error);
  }
}
export async function fetchUpdateApplicationUser(userId: string, params: Partial<ApplicationUser>) {
  try {
    const user = store
      .getState()
      .applicationUsers.find((u) => udidKey(u.Udid) === udidKey(userId));
    if (!user) return false;

    const newUser = { ...user, ...params };
    const data = (await saveFunnerUserDetails(newUser)) as { result?: boolean; message?: string } | null;
    // בדיקת result אמיתית — עד היום כל תשובה (גם כישלון) עדכנה את ה-store אופטימית,
    // והמשתמש גילה שהשמירה נכשלה רק אחרי רענון
    if (data?.result) {
      dispatch(updateSingleApplicationUser({ userId, params }));
      return true;
    }
    console.warn('fetchUpdateApplicationUser: save failed', data?.message);
    return false;
  } catch (error) {
    console.warn('fetchUpdateApplicationUser err: ', error);
    return false;
  }
}
